import { useEffect, useState } from 'react';
import { fetchTemplate, searchTemplates } from '../api/dataApi';
import type { Template } from '../types';

// Every template the signed-in user owns, fully hydrated - what a mapping's
// Signals are matched against ("does this Signal already exist somewhere?").
// Same fetch the auto-map wizard does; [] until loaded or on failure.
export function useOwnedTemplates(): { templates: Template[]; loading: boolean } {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const page = await searchTemplates('mine', '');
        const hydrated = (await Promise.all(page.data.map((n) => fetchTemplate(n)))).filter((t): t is Template => t !== null);
        if (!cancelled) setTemplates(hydrated);
      } catch {
        if (!cancelled) setTemplates([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);
  return { templates, loading };
}
